<template>
  <div class="device-type-rule-item">
    <div class="content-wrap">
      <div class="aside">
        <div class="title">{{ title }}</div>
        <div class="info">
          <el-form ref="form" label-position="top">
            <el-form-item :label="$t('crm_device_type_rule_item.chan_pin_xing_hao')">
              <custom-select
                :url="productListReqUrl"
                width="223px"
                :props="{ label: 'productName', value: 'productCode' }"
                v-model="productList"
                :multiple="true"
                :disabled="type === 'edit'"
                @getList="onGetList"
              ></custom-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="content">
        <div class="title">{{ $t('crm_device_type_rule_item.gui_ze_xiang_qing') }}</div>
        <ul>
          <li v-for="(ruleItem, index) in ruleList" :key="index">
            <div class="tit">{{ ruleItem.value }}</div>
            <div class="sub" v-html="formatRule(ruleItem)"></div>
            <div class="list" v-for="(rule, idx) in ruleItem.rules" :key="idx">
              <div class="and-type ub">
                <div class="ub-f1">
                  <el-radio-group v-model="rule.connectSymbol" style="margin-left: 18px">
                    <el-radio :label="0">{{ $t('crm_device_type_rule_item.ren_yi_tiao_jian') }}</el-radio>
                    <el-radio :label="1">{{ $t('crm_device_type_rule_item.suo_you_tiao_jian') }}</el-radio>
                  </el-radio-group>
                </div>
                <div class="icon-box" style="line-height: 50px; margin-right: 10px" @click="delRule(ruleItem.rules, idx)">
                  <i class="icon icon-shanchu"></i>
                </div>
              </div>
              <div class="and-rule">
                <div class="rule-item ub" v-for="(items, i) in rule.children" :key="i">
                  <el-row :gutter="10" class="ub-f1">
                    <el-col :span="6">
                      <custom-select v-model="items.type" code="dms_device_biz_type_condition" :placeholder="$t('Common.com_please_select')" width="100%" @change="setItemName($event, items)"></custom-select>
                    </el-col>
                    <el-col :span="6">
                      <custom-select v-model="items.symbol" code="isynergy_cloud_symbol" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                    </el-col>
                    <el-col :span="12">
                      <el-input type="number" v-model="items.value" :placeholder="$t('Common.com_please_input')" style="width: 100%"></el-input>
                    </el-col>
                  </el-row>
                  <div class="icon-box" @click="delSymbol(rule.children, i)">
                    <i class="icon icon-shanchu"></i>
                  </div>
                </div>
                <div class="add-child-btn" @click="addSymbol(rule.children)">
                  <div style="display: inline-block">
                    <i class="icon icon-add"></i>
                    <span>{{ $t('crm_device_type_rule_item.tjtjfw') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="role-add-btn" @click="addRule(ruleItem.rules)">
              <div style="display: inline-block">
                <i class="icon icon-add"></i>
                <span>{{ $t('crm_device_type_rule_item.tian_jia_tiao_jian') }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn-group">
      <div class="btn" @click="jump(-1)">{{ $t('Common.com_cancel') }}</div>
      <div class="btn ok" @click="save">{{ saveText }}</div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';
// DeviceBizTypePage DeviceBizTypeInfo DeviceBizTypeAdd DeviceBizTypeUpdate


export default {
  name: 'device_type_rule_item',
  data() {
    return {
      // 页面类型，add, edit, copy
      type: 'add',
      productList: [],
      ruleList: [],
      productCode: '',
    };
  },
  computed: {
    title() {
      const TITLE = {
        ADD: this.$t('crm_device_type_rule_item.xzsblxgz'),
        EDIT: this.$t('crm_device_type_rule_item.bjsblxgz'),
        COPY: this.$t('crm_device_type_rule_item.fzsblxgz'),
      };
      let ret = '';
      switch (this.type) {
        case 'add':
          ret = TITLE.ADD;
          break;
        case 'edit':
          ret = TITLE.EDIT;
          break;
        case 'copy':
          ret = TITLE.COPY;
          break;
        default:
          ret = TITLE.ADD;
          break;
      }
      return ret;
    },
    productListReqUrl() {
      return ['copy', 'add'].includes(this.type) ? 'DeviceBizTypeProductList' : 'productCodeSelectList';
    },
    saveText() {
      return this.type === 'add' ? this.$t('Common.com_add') : this.$t('Common.com_save');
    },
  },
  methods: {
    onGetList() {
      if (this.productCode && this.type !== 'copy') {
        this.productList = [this.productCode];
      }
    },
    addSymbol: function (item) {
      item.push({ type: '', symbol: '', value: '' });
    },
    delSymbol: function (item, index) {
      item.splice(index, 1);
    },
    addRule: function (rules) {
      rules.push({
        connectSymbol: 0,
        children: [{ type: '', typeName: '', symbol: '', value: '' }],
      });
    },
    delRule: function (item, index) {
      item.splice(index, 1);
    },
    formatRule: function (data) {
      const str = this.$t('crm_device_type_rule_item.qtxgztj');
      const ruleStr = [];
      const ruleCode = [];

      data.rules.forEach((item) => {
        const list = item.children.filter(t => t.typeName && t.symbol && t.value);
        const row = list.map(t => `${t.typeName} ${t.symbol} ${t.value}`);
        const row1 = list.map(t => `${t.type} ${t.symbol} ${t.value}`);
        const tip = row.join(item.connectSymbol ? ' & ' : ' || ');
        const tip1 = row1.join(item.connectSymbol ? ' & ' : ' || ');
        if (tip) {
          ruleStr.push(`(${tip})`);
        }
        if (tip1) {
          ruleCode.push(`(${tip1})`);
        }
      });
      data.ruleCode = ruleCode.join('OR');
      data.ruleStr = ruleStr.join('OR');
      return ruleStr.join('<p>OR</p>') || str;
    },
    setItemName: function (obj, item) {
      let val = '';
      if (obj !== undefined) {
        val = typeof obj === 'object' ? obj.value : obj;
      }
      const row = this.propertyMap.dms_device_biz_type_condition.find(t => `${t.value}` === `${val}`) || {};
      item.typeName = row.name;
    },
    validate(cb) {
      if (!this.productList.length) {
        this.$message.error(this.$t('crm_device_type_rule_item.qxzcpxh'));
        cb(false);
        return;
      }
      let isFinish = true;
      this.ruleList.forEach((item) => {
        if (!item.rules.length) {
          isFinish = false;
          cb(false);
          return;
        }
        item.rules.forEach((val) => {
          const list = val.children.filter(t => (t.typeName && t.symbol && t.value) || (!t.typeName && !t.symbol && !t.value));
          if (!list.length) {
            isFinish = false;
          }
        });
      });
      if (!isFinish) {
        this.$message.error(this.$t('crm_device_type_rule_item.qjgztxwc'));
        cb(false);
        return;
      }
      cb(true);
    },
    getReqData(type) {
      const ret = [];
      this.ruleList.forEach((rule) => {
        let flag = true;
        rule.rules.forEach((obj) => {
          if (!obj.children.find(t => t.typeName && t.symbol && t.value)) {
            flag = false;
          }
        });
        if (flag) {
          ret.push(rule);
        }
      });
      return ret.map(item => ({
        ruleCondition: item.ruleCode,
        deviceBizType: item.value,
        productCode: this.productList.join(','),
        ruleId: type === 'copy' ? undefined : item.ruleId,
      }));
    },
    save() {
      if (this.type === 'add') {
        this.create();
      }
      if (this.type === 'edit') {
        this.edit();
      }
      if (this.type === 'copy') {
        this.copy();
      }
    },
    create() {
      this.validate((validate) => {
        if (validate) {
          this.$postJSON(apis.DeviceBizTypeAdd, this.getReqData('create'), true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success'),
            });
            this.clearTagByKeep('device_type_rule_item');
            this.jump('/offer/deviceTypeRule', {}, true);
          });
        }
      });
    },
    edit() {
      this.validate((validate) => {
        if (validate) {
          this.$postJSON(apis.DeviceBizTypeUpdate, this.getReqData('edit'), true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.clearTagByKeep('device_type_rule_item');
            this.jump('/offer/deviceTypeRule', {}, true);
          });
        }
      });
    },
    // copy() {
    //   this.validate((validate) => {
    //     if (validate) {
    //       this.$postJSON(apis.DeviceBizTypeAdd, this.getReqData('copy'), true).then(() => {
    //         this.$message({
    //           type: 'success',
    //           message: '复制成功'
    //         });
    //         this.jump('/offer/deviceTypeRule', { refresh: true }, true);
    //       });
    //     }
    //   });
    // },
    init() {
      this.productCode = this.getJump('productCode');
      this.type = this.getJump('type');
      this.getDictionary('dms_device_biz_type,crm_sharing_rule_condition_type,dms_device_biz_type_condition', (data) => {
        const list = data.dms_device_biz_type;
        const child = { type: '', typeName: '', symbol: '', value: '' };
        const item = {
          connectSymbol: 0,
        };
        list.forEach((items) => {
          // 条件
          this.$set(items, 'str', '');
          this.$set(items, 'rules', [Object.assign({}, item)]);
          items.rules.forEach((val) => {
            // 条件范围
            this.$set(val, 'children', [Object.assign({}, child)]);
          });
        });
        this.ruleList = list; // rules, children

        this.initData();
      });
    },
    initData() {
      if (this.type !== 'add') {
        this.$getJSON(apis.DeviceBizTypeInfo, {
          productCode: this.productCode,
        }).then((res) => {
          const conditions = this.getCondition(res.data);
          const list = this.formateData(conditions);
          this.ruleList = list;
        });
      }
    },
    // 列表可能不完整，需要按照dms_device_biz_type补充完全
    getCondition(list) {
      return this.propertyMap.dms_device_biz_type.map((item) => {
        const conditionItem = list.find(listItem => listItem.deviceBizType === item.value);
        if (conditionItem) {
          return conditionItem;
        } else {
          return {
            deviceBizType: item.value,
            productCode: this.productCode,
          };
        }
      });
    },
    // 将后端返回的列表转为ruleList
    formateData(conditions) {
      return conditions.map(item => ({
        ...item,
        value: item.deviceBizType,
        ruleCode: item.ruleCondition,
        ruleStr: this.ruleCodeToRuleStr(item.ruleCondition),
        rules: this.ruleCodeToRules(item.ruleCondition),
      }));
    },
    // 根据dms_device_biz_type_condition中的value获取dms_device_biz_type_condition中的name
    valueToName(value) {
      const item = this.propertyMap.dms_device_biz_type_condition.find(obj => `${obj.value}` === `${value}`);
      return item.name;
    },
    // 英文表达式转中文表达式
    ruleCodeToRuleStr(ruleCode = '') {
      let ret = ruleCode;
      this.propertyMap.dms_device_biz_type_condition.forEach((item) => {
        ret = ret.replace(new RegExp(item.value, 'g'), item.name);
      });
      return ret;
    },
    ruleCodeToRules(ruleCode = '') {
      if (!ruleCode) {
        return [
          {
            connectSymbol: 0,
            children: [
              {
                type: '',
                typeName: '',
                symbol: '',
                value: '',
              },
            ],
          },
        ];
      }
      const strList = ruleCode.split('OR');
      return strList.map((str) => {
        const connectSymbol = str.includes('&') ? 1 : 0;
        const childStr = str
          .replace('(', '')
          .replace(')', '')
          .split(/&|\|\|/);
        const children = childStr.map((c) => {
          const conditionArr = c.trim().split(' ');
          const type = conditionArr[0];
          const symbol = conditionArr[1];
          const value = conditionArr[2];
          const typeName = this.valueToName(type);
          return {
            type,
            symbol,
            value,
            typeName,
          };
        });
        return {
          connectSymbol,
          children,
        };
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';

.device-type-rule-item {
  background-color: #ffffff;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 80px;
  .btn-group {
    height: 80px;
    text-align: center;
    background-color: #f2f2f2;
    padding-top: 20px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    .btn {
      cursor: pointer;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 110px;
      background-color: #ffffff;
      color: #1e1e1e;
      font-size: 14px;
      &.ok {
        margin-left: 10px;
        background-color: #00afff;
        color: #ffffff;
      }
    }
  }
  .content-wrap {
    width: 1100px;
    margin: 0 auto;
    display: flex;
    .title {
      color: #262626;
      font-size: 16px;
      padding: 20px 0;
    }

    .aside {
      width: 242px;
      border-right: 1px solid #e4e4e4;
      .el-form-item--small.el-form-item {
        margin-bottom: 8px;
      }
    }
    .content {
      flex: 1;
      width: 0;
      padding: 0 0 56px 20px;
      .role-add-btn {
        background: rgba(245, 245, 245, 1);
        border: 1px solid rgba(228, 228, 228, 1);
        line-height: 40px;
        text-align: center;
        color: #333333;
        font-size: 12px;
        margin-top: 10px;
        cursor: pointer;
        .icon {
          color: #00afff;
          font-size: 10px;
          margin-right: 8px;
          float: left;
        }
      }
      ul li {
        border: 1px solid rgba(228, 228, 228, 1);
        position: relative;
        margin-top: 24px;
        padding: 24px 30px;
        .tit {
          width: 42px;
          text-align: center;
          background-color: #ffffff;
          position: absolute;
          line-height: 45px;
          color: #00afff;
          font-size: 32px;
          font-weight: bold;
          top: -23px;
          left: 20px;
        }
        .sub {
          color: #818181;
          font-size: 12px;
          line-height: 30px;
          margin-bottom: 25px;
        }
        .list {
          border: 1px solid rgba(228, 228, 228, 1);
          margin-bottom: 10px;
          .and-type {
            background-color: #f5f5f5;
            line-height: 50px;
            border-bottom: 1px solid rgba(228, 228, 228, 1);
          }
          .and-rule {
            padding: 14px 10px;
          }
        }
        .rule-item {
          margin-bottom: 5px;
        }
        .icon-box {
          line-height: 30px;
          width: 30px;
          margin-left: 10px;
          text-align: center;
          .icon {
            color: #00afff;
            font-size: 14px;
            cursor: pointer;
          }
        }
        .add-child-btn {
          background: rgba(245, 245, 245, 1);
          border: 1px dashed rgba(228, 228, 228, 1);
          line-height: 30px;
          text-align: center;
          color: #333333;
          font-size: 12px;
          margin-top: 10px;
          cursor: pointer;
          .icon {
            color: #00afff;
            font-size: 10px;
            margin-right: 8px;
            float: left;
          }
        }
      }
    }
  }
}
</style>
